
import DioramaPanel from "../../../lib/services/scene/diorama_panel";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import Camera from "../../../lib/services/scene/camera";
import BoxCollisionVolume from "../../../lib/services/collision/box_collision_volume";
import Stage from "../../../lib/services/stage/stage";
export default class Dogbowl extends DioramaPanel
{

  constructor(key: string) 
  {
      super(key,"unlit_texture_alpha","dogbowl",1,1);
      const cbox = new BoxCollisionVolume(
        0.155,0.080,0.126,   // width, height, depth
       -0.012,0.112,-0.038,   // offset x, y, z
        "nav",
        false
      );
      this.add_collision_volume(cbox);
  }

  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
     await super.build(device,format,shader_service,resource_service);
     
    this.register_collisions(Stage.instance().collision_service);

   
    this.transform.set_position(0.900350034236908,0.021569998934864998,5.988553524017334);
    this.transform.set_rotation(0, 0, 0);
    this.transform.set_scale(-0.2645908296108246,0.2645908296108246,0.2645908296108246);
    this.transform.update_matrix();
  }

  tick(delta_time: number): void 
  {
      //this.placement.tick(delta_time);
     //  this.volume_placement.tick(delta_time,0);
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
      super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
      super.draw(pass);
  }
}